import { CheckCircle2 } from "lucide-react";

export default function CheckoutSettlementReview({ preview, currency = "PHP", formatAmount }) {
  if (!preview) return null;

  const routes = Array.isArray(preview.routes) ? preview.routes : [];
  const money = (value) => formatAmount(Number(value || 0), currency);

  return (
    <section
      className="rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4 text-emerald-950 shadow-sm"
      data-testid="checkout-settlement-review"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" strokeWidth={2.25} />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Database review complete</p>
          <p className="mt-1 text-xs text-emerald-800">
            Nothing has been posted yet. Confirm once more to complete this exact settlement.
          </p>

          <dl className="mt-3 grid grid-cols-2 gap-x-5 gap-y-2 text-xs sm:grid-cols-4">
            <div>
              <dt className="text-emerald-700">Due</dt>
              <dd className="mt-0.5 font-semibold tabular-nums">{money(preview.due_today_centavos)}</dd>
            </div>
            <div>
              <dt className="text-emerald-700">Patient payment</dt>
              <dd className="mt-0.5 font-semibold tabular-nums">{money(preview.patient_payment_centavos)}</dd>
            </div>
            <div>
              <dt className="text-emerald-700">Patient AR</dt>
              <dd className="mt-0.5 font-semibold tabular-nums">{money(preview.patient_ar_centavos)}</dd>
            </div>
            <div>
              <dt className="text-emerald-700">Deferred on treatment</dt>
              <dd className="mt-0.5 font-semibold tabular-nums">{money(preview.deferred_centavos)}</dd>
            </div>
          </dl>

          {routes.length > 0 ? (
            <div className="mt-3 border-t border-emerald-200 pt-3" data-testid="checkout-settlement-routes">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-emerald-700">Where the payment goes</p>
              <div className="mt-2 space-y-1.5">
                {routes.map((route, index) => (
                  <div
                    key={`${route.kind || "route"}-${index}`}
                    className="flex items-center justify-between gap-3 text-xs"
                  >
                    <span className="min-w-0 truncate">{route.label || "Checkout balance"}</span>
                    <span className="shrink-0 font-semibold tabular-nums">
                      {money(route.payment_centavos)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
